var amdi18n={"__root":{"app_not_available":"AusweisApp2_mobile is not available","platform_not_supported":" AusweisApp2_mobile doesn't support the current platform","authentication_option_not_supported":"AusweisApp2_mobile doesn't support the given authentication option","started":"Custom protocol recovery strategy started","succeeded":"Custom protocol recovery strategy succeeded","failed":"Custom protocol recovery strategy failed","stopped":"Custom protocol recovery strategy stopped"},"__de":{}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/model/recoverystrategy/nls/CustomProtocolRecoveryStrategy_strings.js
// module id = 298
// module chunks = 3